import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=8c82ae66&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c82ae66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c82ae66')) {
      api.createRecord('8c82ae66', component.options)
    } else {
      api.reload('8c82ae66', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=8c82ae66&scoped=true&", function () {
      api.rerender('8c82ae66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/nav/widget.vue"
export default component.exports